<template>
	<v-sheet id="project-property-reports"
		rounded>
		<reports-table :reports="reports" />
	</v-sheet>
</template>
<script>
import ReportsTable from '@/Pages/Backend/Reports/Table'

export default {
	components: {
		ReportsTable
	},
	props: {
		reports: {
			type: [Array, Object],
			default: () => {},
			required: true
		}
	},
	data () {
		return {
			//
		}
	}
}
</script>
